import React from 'react';
import Style from './TechBadge.module.scss';

const categoryColors = {
    Frontend: '#3B82F6',
    Backend: '#10B981',
    Database: '#F59E0B',
    Cloud: '#8B5CF6',
    Payments: '#EC4899',
    Integrations: '#06B6D4',
    Tools: '#6366F1',
    Cache: '#14B8A6'
};

export default function TechBadge({ name, category }) {
    const color = categoryColors[category] || '#6B7280';
    
    return (
        <span
            className={Style.badge}
            style={{
                backgroundColor: `${color}20`,
                borderColor: color,
                color: color
            }}
            title={category}
        >
            {name}
        </span>
    );
}
